/*!
 * Original code by Chakra UI
 * MIT Licensed, Copyright (c) 2019 Segun Adebayo.
 *
 * Credits to the Chakra UI team:
 * https://github.com/chakra-ui/chakra-ui/blob/main/packages/layout/src/box.tsx
 */

import { hope } from "@hope-ui/styles";

/**
 * `Box` is the most abstract component on top of which other hope ui
 * components are built. It renders a `div` element by default.
 */
export const Box = hope("div");
